import script from "./PageLogin.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageLogin.vue?vue&type=script&lang=ts&setup=true"

import "./PageLogin.vue?vue&type=style&index=0&id=567ea309&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567ea309"]])

export default __exports__